<template>
	<div class="goods room__block" v-if="skuShow">
		<div class="good__panel">
			<div class="good__header">
				<div class="goods-list__header_business" v-if="business">
					<img
						class="goods-list__header_business_logo"
						:src="business.logo"
					/>
					<span class="goods-list__header_business_name">{{
						business.name
					}}</span>
				</div>
				<img
					class="goods-list__header_close global_pointer"
					@click="closeGood"
					:src="require('@/assets/imgs/close.png')"
				/>
			</div>

			<div class="good__body">
				<div class="good__item">

					<div class="good__unit">
						<div class="goods-list__poster">
							<img :src="current.merchandiseImg.url" />
							<span v-if="current.notice.hasStock === 0">{{
								$t("message.goods.sellOut")
							}}</span>
						</div>
						<div class="good__info">
							<div class="good__name">
								{{ current.merchandiseName }}
							</div>

							<div class="good__price">
								<div class="good__price-text">
									{{ current.miniAmountMoney.symbol }}
									{{
										$currencyFormatter(
											current.miniAmountMoney.number
										)
									}}
									<span class="mini_shelf_price" v-if="current.shelfAmountMoney" >
										({{
											`${
												current.shelfAmountMoney.symbol
											}${$currencyFormatter(
												current.shelfAmountMoney.number
											)}`
										}})
									</span>
								</div>
								<!-- <div class="goods-list__price-off"></div> -->
							</div>

							<div
								v-if="current.miniOrgAmountMoney"
								class="good__value"
							>
								{{ current.miniOrgAmountMoney.symbol }}{{ $currencyFormatter( current.miniOrgAmountMoney.number ) }}
							</div>
						</div>
					</div>

                    <!-- 平台服务费说明文案 -->
                    <div class="service-fee-info" v-if="serviceFeeInfo && serviceFeeInfo.length">
                        {{ serviceFeeText }}
                        <span v-if="serviceFeeInfo[1]">{{ serviceFeeInfo[1] }}</span>
                    </div>

					<div v-if="skus.length > 0" class="good__sku">

						<div v-for="sku in skus" :key="sku.type" @click="selectHandle(sku.type)" class="good__selector global_pointer" >
							<div v-show="currentSolect !== sku.type" class="good__sku_name" >
								{{
									sku.checked && sku.checked.length > 0
										? sku.checkedName
										: sku.label
								}}
							</div>

							<div v-show="currentSolect !== sku.type" class="good__sku_arrow"></div>

							<ul v-if="currentSolect === sku.type" class="good__selector_list">
								<li v-for="item in sku.list" :key="item.id" class="global_pointer" @click="selectSku(item, sku.type)" >
									{{ item.label }}
								</li>
							</ul>
						</div>

					</div>

					<div @click="buy" class="good__buy good__btn global_pointer">
						{{ $t("message.goods.buyNow") }}
					</div>
					<div @click="saveCart" class="good__cart good__btn global_pointer">
						{{ $t("message.goods.addCart") }}
					</div>
					<!-- <div class="divider"></div> -->
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import api from "@/api/api_list.js";
import { getDeviceId } from "@/utils";
export default {
	props: {},
    computed: {
        serviceFeeText() {
            if (this.serviceFeeInfo && this.serviceFeeInfo.length) {
                const text = this.serviceFeeInfo[1]
                if (text) {
                    const index = this.serviceFeeInfo[0].indexOf(text)
                    if (index !== -1) {
                        return this.serviceFeeInfo[0].substring(0, index)
                    }
                }
                return this.serviceFeeInfo[0]
            }
        },
    },
	data() {
		return {
			skuShow: false,
			current: {},
			skus: [],
			skuInfo: [],
			miniSkuId: "",
			currentSolect: void 0,
            serviceFeeInfo: []
		};
	},
	methods: {
		open(input = {}) {
			const {
				goods,
				business,
				liveId,
				closeCallback,
				addCartComplete,
				errorCallback,
			} = input;

			this.skuShow = true;
			this.business = business;
			this.liveId = liveId;
			this.closeCallback = closeCallback;
			this.addCartComplete = addCartComplete;
			this.errorCallback = errorCallback;
			this.init(goods);
		},
		close() {
			this.closeCallback ? this.closeCallback() : null;
			this.skuShow = false;
			this.$sku.close();
		},

		async init(item) {
			this.current = JSON.parse( JSON.stringify(item) );
			this.skus = [];

			try{
				let res = await api.list_merchandise_sku({
					merchandiseId: item.id,
				});

				let {
					skuInfo,
					merchandiseOptions,
					miniSkuId,
					supportRefund,
				} = res.result;

				// 是否支持退换
				this.current.supportRefund = supportRefund;

				let skuTemp = {};

				merchandiseOptions.map((opt) => {

					if (skuTemp[opt.attributeType] === void 0) {
						skuTemp[opt.attributeType] = {};
						skuTemp[opt.attributeType].type = opt.attributeType;
						skuTemp[opt.attributeType].label = this.$i18n.locale === 'en'?opt.attributeNameEn : opt.attributeName;
						skuTemp[opt.attributeType].list = new Array();
						// 储存格式化后的sku信息
						this.skus.push( skuTemp[opt.attributeType] );
					}

					skuTemp[opt.attributeType].list.push({
						id: opt.id,
						sort: opt.sort,
						label: this.$i18n.locale === 'en' ? opt.attributeValueEn : opt.attributeValue
					});

				});
				
				this.skus.forEach((sku) => {
					sku.list.sort((a, b) => {
						return Number(a.sort) - Number(b.sort);
					});
				});

				this.skuInfo = skuInfo;
				this.miniSkuId = miniSkuId;
				this.listShow = false;

			}catch(e){
				this.$toast("获取 sku 信息失败");
			}
			
		},


		closeGood() {
			Object.assign(this.$data, this.$options.data());
		},
		selectHandle(type) {
			if (this.currentSolect == type) {
				this.currentSolect = void 0;
			} else {
				this.currentSolect = type;
			}
		},

		selectSku(item, type) {
			let skuTemp = this.skus.find((i) => i.type === type);
			if (skuTemp.checked && skuTemp.checked === item.id) return;
			skuTemp.checked = item.id;
			skuTemp.checkedName = item.label;
			this.refreshPrice();
		},

		refreshPrice() {
			if (this.allChecked()) {
                this.checkSku()
				// let str = this.skus.reduce((acc, cur) => {return acc + `,${cur.checked}`}, '').substring(1)
				// let choosen = this.skuInfo.find(item => item.skuAttrs.join(',') === str)
				let choosen = this.skuInfo.find((item) => {
					return this.skus.every((sku) => item.skuAttrs.includes(sku.checked) );
				});

				console.log( 'current::::' , this.current, choosen);

				if (!choosen) {
					this.current.notice.hasStock = 0;
					return;
				}

				this.formatCurrent(choosen);
				return;
			}
			return;
		},

		allChecked() {
			return this.skus.every((i) => i.checked && i.checked.length > 0);
		},
        // 设置sku平台服务费文案
        checkSku() {
            const selectSku = [];
            this.skus.forEach(item => {
                selectSku.push(item.checked);
            })
            if (this.skuInfo && this.skuInfo.length) {
                for (let i = 0; i < this.skuInfo.length; i++) {
                    if (this.isEqual(this.skuInfo[i].skuAttrs, selectSku)) {
                        this.serviceFeeInfo = this.skuInfo[i].serviceFeeInfo
                        break
                    } else {
                        this.serviceFeeInfo = []
                    }
                }
            }
        },
        isEqual(skuAttrs, selectSku) {
            let isInclude = true
            const selectArrs = Object.values(selectSku)
            if (skuAttrs.length !== selectArrs.length) {
                return false
            }
            skuAttrs.forEach(item => {
                if (!selectArrs.includes(item)) {
                    isInclude = false
                }
            })
            return isInclude
        },

		formatCurrent(choosen) {
			this.current.merchandiseImg = choosen.coverImgKey;
			this.current.miniAmountMoney = choosen.amountMoney;
			this.current.miniOrgAmountMoney = choosen.orgAmountMoney;
			this.current.skuId = choosen.id;
			this.current.notice.hasStock = Number(choosen.stock) !== 0 ? 1 : 0;

			this.current.shelfAmountMoney = choosen.shelfAmountMoney;
			this.current.userDiscount = choosen.userDiscount;
			this.current.userDiscountStr = choosen.userDiscountStr;
		},

		validateOrder() {
			if (!this.allChecked()) {
				this.$toast(this.$t("message.shop.note.skuRequired"));
				return;
			}
			if (this.current.notice.hasStock === 0) {
				this.$toast(this.$t("message.shop.note.sellOut"));
				return;
			}
			return true;
		},
		buy() {
			this.$shareGuide.open(); // 打开引导下载弹层
			this.skuShow = false;
			return;
			// if (!this.validateOrder()) return;
			// if (this.current.notice.hasStock === 0)
			// 	// return this.$toast("英文：没库存了");
			// 	return this.$toast( this.$t("message.shop.note.sellOut") );
			// let skuText = this.skus
			// 	.reduce((acc, cur) => {
			// 		return acc + ` | ${cur.label}：${cur.checkedName}`;
			// 	}, "")
			// 	.substring(3);
			// // 商品信息必须从详情页带入
			// this.current.skuText = skuText;
			// this.current.merchandiseId = this.current.id;

			// this.skuShow = false;
			// this.$order.open({ checked: [this.current], liveId: this.liveId });
		},
		async saveCart() {
			this.$shareGuide.open(); // 打开引导下载弹层
			this.close();
			return;
			// if (!this.validateOrder()) return;
			// if (this.current.notice.hasStock === 0)
			// 	// return this.$toast("英文：没库存了");
			// 	return this.$toast( this.$t("message.shop.note.sellOut") );
			// await api
			// 	.save_cart({
			// 		buyNum: 1,
			// 		deviceId: getDeviceId(),
			// 		merchandiseId: this.current.id,
			// 		skuId: this.current.skuId,
			// 		topicId: this.liveId,
			// 	})
			// 	.then((res) => {
			// 		if (res.code == 0) {
			// 			return this.$toast(
			// 				this.$t("message.shop.note.addCertCb")
			// 			);
			// 		} else {
			// 			return this.$toast(res.msg);
			// 		}
			// 	});
		},
	},
};
</script>

<style lang="less" scoped>
.mini_shelf_price {
	color: #aaa;
	font-size: 12px;
	font-weight: normal;
	font-family: "PingFang SC";
}

.warp() {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.scroll() {
	scrollbar-width: none;
	-ms-overflow-style: none;
	overflow-x: hidden;
	overflow-y: auto;
}
.goods-list,
.good {
	font-weight: normal;
	&__panel {
		width: 100%;
		max-width: 10rem;
		background: #ffffff;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
		max-height: 396px;
		position: absolute;
		left: 0;
		bottom: 0;
		right:0;
		margin: 0 auto;
		z-index: 100;
		box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.1);
	}
	&__header {
		height: 50px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		&_close {
			width: 26px;
			margin-right: 12px;
		}
		&_business {
			margin-left: 16px;
			height: 25px;
			display: flex;
			align-items: center;
			&_logo {
				width: 24px;
				margin-right: 4px;
				border-radius: 50%;
			}
			&_name {
				font-size: 15px;
				font-weight: normal;
				color: #333333;
			}
		}
	}
	&__body {
		width: 100%;
		max-height: 346px;
		box-sizing: border-box;
		padding: 0 16px;
		margin-top: 16px;
		text-align: left;
		.scroll();
	}
	&__item {
		margin-bottom: 24px;
	}
	&__unit {
		height: 100px;
		display: flex;
		align-items: flex-start;
		margin-bottom: 16px;
	}
	&__poster {
		width: 100px;
		height: 100px;
		position: relative;
		overflow: hidden;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		> div {
			position: absolute;
			left: 0;
			top: 0;
			width: 30px;
			height: 22px;
			line-height: 22px;
			background: rgba(0, 0, 0, 0.4);
			border-radius: 8px 0;
			font-size: 15px;
			font-weight: normal;
			color: #ffffff;
			text-align: center;
		}
		img {
			width: 100%;
			border-radius: 8px;
		}
		span {
			display: block;
			position: absolute;
			left: 0;
			bottom: 0;
			width: 100%;
			height: 25px;
			line-height: 25px;
			background: rgba(246, 99, 85, 0.8);
			border-bottom-left-radius: 8px;
			border-bottom-right-radius: 8px;
			text-align: center;
			color: #ffffff;
		}
	}
	&__info {
		flex: 1;
		box-sizing: border-box;
		padding-left: 18px;
	}
	&__name {
		max-width: 200px;
		font-size: 15px;
		font-weight: 600;
		color: #000000;
		margin-bottom: 8px;
		.warp();
	}
}
.service-fee-info{
    font-size: 12px;
    padding: 0 0 20px;
    span{
        color: #F37C47;
    }
}
.goods-list {
	&__price {
		&-text {
			font-size: 20px;
			font-weight: 600;
			color: #345547;
		}
		&-value {
			font-size: 12px;
			font-weight: normal;
			color: #999999;
			text-decoration: line-through;
			display: inline-block;
			margin-left: 4px;
		}
	}
	&__off {
		width: 36px;
		height: 14px;
		line-height: 14px;
		box-sizing: border-box;
		background: #fc5b3f;
		border-radius: 11px;
		font-size: 10px;
		font-weight: 600;
		color: #ffffff;
		text-align: center;
	}
	&__btn {
		width: 100%;
		display: flex;
		height: 25px;
		justify-content: flex-end;
		align-items: center;
		&-buy {
			width: 68px;
			height: 24px;
			line-height: 24px;
			text-align: center;
			background: #000000;
			border-radius: 14px;
			font-size: 12px;
			font-weight: normal;
			color: #ffffff;
		}
	}
}
.good {
	&__price {
		margin-bottom: 8px;
		&-text {
			font-size: 20px;
			font-weight: 600;
			color: #345547;
		}
	}
	&__value {
		font-size: 14px;
		font-weight: normal;
		color: #666666;
		line-height: 18px;
		text-decoration: line-through;
	}
	&__sku {
		height: 1.54erm;
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		&_name {
			flex: 1;
			height: 46px;
			line-height: 46px;
			text-align: center;
			font-size: 15px;
			font-weight: normal;
			color: #000000;
		}
		&_arrow {
			margin-right: 15px;
			width: 17px;
			height: 16px;
			background: url("../../../assets/imgs/goods/select.png") center
				no-repeat;
			background-size: 100% 100%;
		}
	}
	&__selector {
		width: 148px;
		height: 46px;
		border-radius: 23px;
		border: 1px solid #000000;
		display: flex;
		align-items: center;
		position: relative;
		margin-bottom: 5px;
		> ul {
			padding: 0;
			position: absolute;
			left: -1px;
			top: 50%;
			z-index: 1;
			width: 150px;
			background: #ffffff;
			border: 1px solid #000000;
			border-bottom-left-radius: 15px;
			border-bottom-right-radius: 15px;
			border-top: none;
			max-height: 145px;
			.scroll();
			> li {
				width: 100%;
				height: 46px;
				line-height: 46px;
				text-align: center;
			}
		}
	}
	&__btn {
		margin-top: 21px;
		width: 100%;
		height: 46px;
		line-height: 46px;
		font-size: 15px;
		border-radius: 23px;
		text-align: center;
	}
	&__buy {
		background: #222222;
		color: #ffffff;
	}
	&__cart {
		background: #f2f2f2;
		color: #000000;
		margin-bottom: 21px;
	}
}
</style>
